import React, { useEffect, useState } from "react"

import cn from "classnames"

import { CategoryWithChildren } from "../CategoryStep"
import selectedIcon from "./assets/selectedIcon.svg"
import unselectedIcon from "./assets/unselectedIcon.svg"
import ColorableSVG from "~/components/ColorableSVG/ColorableSVG"
import Separator from "~/components/Separator/Separator"
import { Body } from "~/components/ui"

import css from "./RecursiveCategoryTree.module.scss"

interface PropTypes {
  categories: CategoryWithChildren[]
  setSelectedCategoryId: (id: string | null) => void
  selectedCategoryId: string | null
  level: number
}
const RecursiveCategoryTree = ({
  categories,
  setSelectedCategoryId,
  selectedCategoryId,
  level,
  ...rest
}: PropTypes) => {
  const [indexSelected, setIndexSelected] = useState<null | number>(null)
  const [enable, setEnable] = useState(level === 0)

  useEffect(() => {
    setEnable(true)
  }, [])

  const handleClick = (index: number, categoryId: string) => {
    if (indexSelected == index) {
      setIndexSelected(null)
      setSelectedCategoryId(null)
    } else {
      setIndexSelected(index)
      setSelectedCategoryId(categoryId)
    }
  }

  return (
    <div className={cn(css.root)}>
      {categories.map((category, index) => {
        return (
          <React.Fragment key={index}>
            <div
              onClick={() => handleClick(index, category.categoryId)}
              className={cn(css.row, { [css.enable]: enable })}
            >
              <Body variant="body2" semiBold={level === 0}>
                {category.name}
              </Body>

              <ColorableSVG
                href={indexSelected === index ? selectedIcon : unselectedIcon}
                width="23"
                height="23"
                mainColor={
                  selectedCategoryId == category.categoryId
                    ? "var(--original-color)"
                    : "var(--gray2-color)"
                }
              />
            </div>
            {indexSelected === index && category.children.length > 0 && (
              <div className={css.selectedCategoryTree}>
                <div style={{ marginLeft: `${-16 * (level + 1)}px` }}>
                  <Separator noMargin />
                </div>
                <RecursiveCategoryTree
                  categories={category.children}
                  setSelectedCategoryId={setSelectedCategoryId}
                  selectedCategoryId={selectedCategoryId}
                  level={level + 1}
                />
              </div>
            )}
            {categories.length !== index + 1 && (
              <div style={{ marginLeft: `${-16 * level}px` }}>
                <Separator noMargin />
              </div>
            )}
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default RecursiveCategoryTree
